import axios from '@/libs/api.request'

// 获取投诉建议列表
export const ComplaintList = (data) => {
  return axios.request({
    url: 'option/complaintlist',
    data: data,
    method: 'post',
  })
}

// 删除投诉建议
export const ComplaintDel = (data) => {
  return axios.request({
    url: 'option/complaintdel',
    data: data,
    method: 'post',
  })
}

// 更新投诉建议状态（待处理/已处理）
export const ComplaintStatus = (data) => {
  return axios.request({
    url: 'option/complaintstatus',
    data: data,
    method: 'post',
  })
}